export const TABLEAU_POD_URL = 'https://10ay.online.tableau.com';

// Loaded via a <script> tag rather than the @tableau/embedding-api npm package — that package's
// transitive deps (@tableau/api-shared-js and friends) are currently unpublished from the public
// npm registry. Tableau serves the same embedding API JS directly from the pod hosting the view.
export const TABLEAU_EMBED_SCRIPT_URL = `${TABLEAU_POD_URL}/javascripts/api/tableau.embedding.3.latest.min.js`;

// 8 minutes — comfortably inside the JWT's expiry window so the token never goes stale mid-view.
export const TABLEAU_TOKEN_REFRESH_MS = 1000 * 60 * 8;
